class IndividualMessageStateDTO {
    public Id: string;
    public TaskStatusLookupId: string;
    public ToContactId: string;
    public IndividualMessageId: string;
    public LastStatusUpdatedDate: Date;
}

export { IndividualMessageStateDTO };
